// extracted by mini-css-extract-plugin
export default {"__risk_level":"LevelChip___risk_level__LZhBg","high":"LevelChip_high__XRfbO","medium":"LevelChip_medium__wfTgX","low":"LevelChip_low__BDPST"};